import attendRouter from '~cfg/router/nrw/child/attendRouter.js'

import searchRouter from '~cfg/router/nrw/child/searchRouter.js'
import mySpaceRouter from '~cfg/router/nrw/child/mySpaceRouter.js'

import custCntrRouter from '~cfg/router/nrw/child/custCntrRouter.js'
import eventRouter from '~cfg/router/nrw/child/eventRouter.js'

import boardRouter from '~cfg/router/nrw/child/boardRouter.js'

import courseRouter from '~cfg/router/nrw/child/courseRouter.js'
import memberRouter from '~cfg/router/nrw/child/memberRouter.js'
import paymentRouter from '~cfg/router/nrw/child/paymentRouter.js'
import callbackRouter from '~cfg/router/nrw/child/callbackRouter.js'

import promoRouter from '~cfg/router/nrw/child/promoRouter.js'

import eudCalRouter from '~cfg/router/nrw/child/eudCalRouter.js'

export default [
  ...attendRouter,
  ...searchRouter,
  ...mySpaceRouter,
  ...custCntrRouter,
  ...eventRouter,

  ...boardRouter,

  ...courseRouter,
  ...memberRouter,
  ...paymentRouter,
  ...callbackRouter,

  ...promoRouter,

  ...eudCalRouter
]



// WEBPACK FOOTER //
// ./src/config/router/nrw/NrwRouter.js